const XMLHttpRequestResponseTypeEnum = Object.freeze({
  none: '',
  arraybuffer: 'arraybuffer',
  blob: 'blob',
  document: 'document',
  json: 'json',
  text: 'text',
});

export default XMLHttpRequestResponseTypeEnum;
